import React, { useState, useEffect } from "react";
import "./Dashboard.css";
import Tooltip from "react-bootstrap/Tooltip";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import { Button, Row, Col, Nav, Tab, Card } from "react-bootstrap";
import * as Icon from "react-bootstrap-icons";
import { getFromLS, setToLS } from "../../utils/storage";
import Accordion from 'react-bootstrap/Accordion';
import { useAccordionButton } from 'react-bootstrap/AccordionButton';
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../../context/AuthProvider.js";

// Themes setting
import themes from "../../themes/themes.json";
import chart_themes from "../../themes/chart_themes.json";

// Dashboard Pills
import RecommendedWorkflows from "../RecommendationWorkflow";
import VendorDetails from "../vendorDetails";
import FirmDetails from "../firmDetails";
import FirmReports from "../FirmReports";
import FirmJobs from "../FirmJobs";
import ManageUsers from "../ManageUsers";
import CrossReference from "../crossReference";
import MaintanenceReports from "../MaintanenceReports";
import AutomatedReports from "../AutomatedReports";
import MyFlows from "../MyFlows";
import ReportDashboard from "../ReportDashboard/ReportDashboard";
import CygnusGptDashboard from "../CygnusGPT"
import FormLayout from "../DynamicForm/layout";
import MyForms from "../DynamicForm/myforms/myforms";
import MyKones from "../K1/K1LandingPage/konehome";
import ClientOnboarding from "../../separate_apps/ClientOnboarding/clientonboarding.js";
import StaffCreation from "../StaffCreation/staffcreation";
import TaskCreation from "../TaskCreation/taskcreation";
import SuperAdmin from "../SuperAdmin/SuperAdmin";
import FirmAdmin from "../FirmAdmin/FirmAdmin";
import FlowUsageMetrics from "../MaintanenceReports/FlowUsageMetrics.js";

// Intelligence report Pills
import BillableReport from "../reports/BillableNonBillableReport/BillableReport";
import MonthlyTaskStatusReport from "../reports/MonthlyTaskStatusReport/MonthlyTaskStatusReport";
import JurisdictionReport from "../reports/JurisdictionReport/JurisdictionReport";
import RolesEngagement from "../reports/RolesEngagementReport/RolesEngagement";
import StaffingReport from "../reports/StaffingReport/StaffingReport";
import TaskDetailsReport from "../reports/TaskDetailsReport/TaskDetailsReport";
import ComingSoonTemplate from "../reports/ComingSoonTemplate/ComingSoonTemplate.js";
import WorkDistributionReport from "../reports/WorkDistributionReport/WorkDistributionReport";
import ClientOnboardingConfigFlow from "../../separate_apps/ClientOnboarding/clientonboardingconfigflow.js";
import { ConfirmationModal } from "./ConfirmationModal";
import { logout } from "../../utils/index.js";
import FlowReport8879 from "../FlowReport8879/FlowReport8879";

const Dashboard = () => {
  const location = useLocation();

  // User details
  const firm_id = localStorage.getItem("firmId");
  const user = localStorage.getItem("user");
  const usertype = localStorage.getItem("usertype");
  const firmname = localStorage.getItem("firmname")
  const availableFeatures = getFromLS("active-features")
  // console.log("Available features = ", availableFeatures)
  const auth = useAuth();
  const navigate = useNavigate()

  const handleLogout = () => {
    auth.logout();
    localStorage.removeItem("token");
    localStorage.removeItem("firmId");
    localStorage.removeItem("user");
    localStorage.removeItem("username");
    localStorage.removeItem("usertype");
    localStorage.removeItem("firmname");
    localStorage.setItem("active-features", []);
    // localStorage.clear()
    navigate("/login");
  };

  const clearCache = () => {
    localStorage.clear();
    window.location.reload();
    // navigate(currPath)
  };

  const setThemer = (result) => {
    console.log("SET THEMER: ", result)
    // console.log("GET THEME api result: ", JSON.parse(result.data[0].params[0].parameter_value_1))
    // setAllThemes(JSON.parse(result.data[0].params[0].parameter_value_1));
    if (result.data[0].params.length > 0) {
      setToLS(
        "all-themes",
        JSON.parse(result.data[0].params[0].parameter_value_1)
      );
    }
    // console.log("After setting allThemes: ", allThemes)
  };

  const getThemes = () => {
    const parameter_name = "themes";
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ firm_id, parameter_name }),
    };
    // console.log('Get themes requestOptions:`, requestOptions)
    fetch(
      `${process.env.REACT_APP_BASE_URI}/workflow/personalization/get_params/`,
      requestOptions
    )
      .then((result) => result.json())
      .then((res) => setThemer(res));
  };

  useEffect(() => {
    getThemes();
    getActiveThemes(true) // for chart theme
    getActiveThemes(false) // for normal theme

    const isDashboard = location.pathname === "/dashboard";
    if (isDashboard)
      localStorage.setItem("defaultActiveKey", "myflows");
  }, []);


  const setActiveThemes = (chart, activeTheme) => {
    const parameter_value_1 = JSON.stringify(activeTheme);
    const parameter_name = chart ? "activeChartTheme" : "activeTheme";
    const payload = { firm_id, parameter_name, parameter_value_1 };
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    };
    fetch(
      `${process.env.REACT_APP_BASE_URI}/workflow/personalization/set_params/`,
      requestOptions
    ).then((result) => result.json());
  };

  const getActiveThemes = (chart) => {
    const parameter_name = chart ? "activeChartTheme" : "activeTheme";
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ firm_id, parameter_name }),
    };
    fetch(
      `${process.env.REACT_APP_BASE_URI}/workflow/personalization/get_params/`,
      requestOptions
    )
      .then((result) => result.json())
      .then((res) => storeActiveThemeValues(chart, res))
  }

  const storeActiveThemeValues = (chart, res) => {
    if (res.data[0].params.length === 0 && !chart) {
      setActiveThemes(chart, themes.data["light"])
    } else if (res.data[0].params.length === 0 && chart) {
      setActiveThemes(chart, chart_themes.data["Tableau Classic 10"])
    } else {
      // setActiveThemes(false, themes.data["light"])
      // setActiveThemes(true, chart_themes.data["Tableau Classic 10"])
      !chart ? setToLS("theme", JSON.parse(res.data[0].params[0].parameter_value_1)) : setToLS("chart-theme", JSON.parse(res.data[0].params[0].parameter_value_1))
      // window.location.reload()
    }
  }

  // Sidenav open close feature
  let [isOpen, setIsOpen] = useState(false);
  let [forcedOpen, setForcedOpen] = useState(false);
  let [logoutIcon, setLogoutIcon] = useState(false)
  const openNav = () => {
    document.getElementById("mySidenav").style.width = "250px";
    document.getElementById("dashboard-content").style.marginLeft = "250px";
    if (document.getElementById("flexible-width") !== null) {
      document.getElementById("flexible-width").style.marginLeft = "250px";
    }
    setTimeout(() => {
      setIsOpen(true);
    }, 0);
  };
  const closeNav = () => {
    document.getElementById("mySidenav").style.width = "70px";
    document.getElementById("dashboard-content").style.marginLeft = "70px";
    if (document.getElementById("flexible-width") !== null) {
      document.getElementById("flexible-width").style.marginLeft = "80px";
    }
    setIsOpen(false);
  };

  const sidenavOpenDoor = () => {
    setLogoutIcon(true)
  }
  const sidenavCloseDoor = () => {
    setLogoutIcon(false)
  }
  // Setting default opening pill based on user (this is hard coded right now)
  // Done in Login.js

  // Navigate with props to bring in dynamic behaviour
  /**
   * 
   * @param {*} pill : This arguement tells us where to navigate, there is no default value.
   * @param {*} mapping_option : This arguement is by default null and is only used when navigating to mapping page.
   * @param {*} report_navigator : This is a boolean arguement which tells us if navigation is within Intelligence
   *                               report and we then do not need to update dashboard nav-pills
   */
  const navigateWithData = (pill, options = { mapping_option: null, credential_option: null, maintenancereport_option: null, usagemetricreport_option: null, automationreport_option: null, createform_option: null, report_navigator: false }) => {
    navigate("/dashboard");

    const mapping_option = options.mapping_option;
    const credential_option = options.credential_option;
    const maintenancereport_option = options.maintenancereport_option;
    const createform_option = options.createform_option;
    const automationreport_option = options.automationreport_option;
    const report_navigator = options.report_navigator;
    const usagemetricreport_option = options.usagemetricreport_option;

    if (pill != undefined && pill.length != 0) {
      if (report_navigator) {
        // here we only navigate to report but do not change the active dashboard pill
        setRender(RENDER_MAP[pill]);
      } else if (mapping_option != null || mapping_option != undefined) {
        // here we navigate to mapping with a mapping_option for pre-selected dropdown
        // change the active dashboard pill to mapping
        setActiveKey(pill);
        setRender(CustomMappingRender(mapping_option));
      } else if (credential_option != null || credential_option != undefined) {
        // here we navigate to credentials with a credential_option for pre-selected dropdown
        // change the active dashboard pill to credentials
        setActiveKey(pill);
        setRender(CustomCredentialRender(credential_option));
      } else if (maintenancereport_option != null || maintenancereport_option != undefined) {
        // here we navigate to credentials with a maintenancereport_option for pre-selected dropdown
        // change the active dashboard pill to maintenancereport
        setActiveKey(pill);
        setRender(CustomMaintenanceReportRender(maintenancereport_option));
      } else if (usagemetricreport_option != null || usagemetricreport_option != undefined) {
        // here we navigate to credentials with a usagemetricreport_option for pre-selected dropdown
        // change the active dashboard pill to usagemetricreport_option
        setActiveKey(pill);
        setRender(CustomUsageMetricReportRender(usagemetricreport_option));
      } else if (automationreport_option != null || automationreport_option != undefined) {
        // here we navigate to credentials with a automationreport_option for pre-selected dropdown
        // change the active dashboard pill to automationreport
        setActiveKey(pill);
        setRender(CustomAutomationReportRender(automationreport_option));
      } else if (createform_option != null || createform_option != undefined) {
        // here we navigate to credentials with a automationreport_option for pre-selected option
        // change the active dashboard pill to createform
        console.log("ACTIVE PILL BEING SET WHEN GONE THROUGH!", pill)
        setActiveKey(pill);
        setRender(CustomFormLayoutRender(createform_option));
      }
      else {
        // here we navigate to pill and change the active dashboard pill to selected Pill
        if (["dynamicform"].includes(activeKey)) {
          setConfirmationModal(true)
          setNavigationData(pill)
        } else {
          setActiveKey(pill);
          setRender(RENDER_MAP[pill]);
        }
      }
      localStorage.setItem("defaultActiveKey", pill);

    } else if (pill != "empty") {
      setRender(RENDER_MAP[pill]);
    } else {
      console.log("NO PAGE FOUND TO NAVIGATE.")
    }
  };

  const CustomMappingRender = (mapping_option) => {
    // console.log("IS THIS CUSTOM FUNCTION BEING CALLED?", mapping_option)
    return (
      <CrossReference mapoption={mapping_option} transporter={navigateWithData} />
    )
  }

  const CustomMaintenanceReportRender = (report_option) => {
    // console.log("IS THIS CUSTOM FUNCTION BEING CALLED?", report_option)
    return (
      <MaintanenceReports reportoption={report_option} transporter={navigateWithData} />
    )
  }
  const CustomUsageMetricReportRender = (report_option) => {
    // console.log("IS THIS CUSTOM FUNCTION BEING CALLED?", report_option)
    return (
      <FlowUsageMetrics reportoption={report_option} transporter={navigateWithData} />
    )
  }

  const CustomAutomationReportRender = (report_option) => {
    // console.log("IS THIS CUSTOM FUNCTION BEING CALLED?", report_option)
    return (
      <AutomatedReports reportoption={report_option} transporter={navigateWithData} />
    )
  }

  const CustomCredentialRender = (credential_option) => {
    // console.log("IS THIS CUSTOM FUNCTION BEING CALLED?", credential_option)
    return (
      <VendorDetails credentialoption={credential_option} transporter={navigateWithData} />
    )
  }

  const CustomFormLayoutRender = (createform_option) => {
    // console.log("IS THIS CUSTOM FUNCTION BEING CALLED?", createform_option)
    return (
      <FormLayout createformoption={createform_option} transporter={navigateWithData} />
    )
  }

  const redirectToExternalCygnusSites = (site) => {
    let url = null
    if (process.env.REACT_APP_ENV == "dev") {
      if (site === "MDM")
        url = process.env.REACT_APP_DEV_CLIENT_DATAMANAGEMENT_URL;
      else if (site === "K1")
        url = process.env.REACT_APP_DEV_CYGNUS_K1_TAX_URL;
    }
    else if (process.env.REACT_APP_ENV == "prod") {
      if (site === "MDM")
        url = process.env.REACT_APP_PROD_CLIENT_DATAMANAGEMENT_URL;
      else if (site === "K1")
        url = process.env.REACT_APP_DEV_CYGNUS_K1_TAX_URL;
    }

    if (url) {
      window.open(url, '_blank');
    }
    else {
      console.error("invalid environment configuration")
    }
  }

  /**
   *  Global mapper for page navigation
   *                                !!!!! WARNING !!!!
   *  Please do not change any of the existing keys in RENDER_MAP as they are being used in different places. 
   *                       Doing so may end up breaking the functionality.
   */
  const RENDER_MAP = {
    // Admins
    superadmin: <SuperAdmin transporter={navigateWithData} />,
    firmadmin: <FirmAdmin transporter={navigateWithData} />,
    // Dashboard pills: Page component
    myapps: <FirmDetails transporter={navigateWithData} />,
    recommendation: <RecommendedWorkflows transporter={navigateWithData} />,
    myflows: <MyFlows transporter={navigateWithData} />,
    credentials: <CustomCredentialRender />,
    mapping: <CustomMappingRender />,
    flowschedule: <FirmJobs transporter={navigateWithData} />,
    report: <FirmReports transporter={navigateWithData} />,
    manage: <ManageUsers transporter={navigateWithData} />,
    maintenancereport: <CustomMaintenanceReportRender />,
    usagemetricreport: <FlowUsageMetrics />,
    automatedreport: <CustomAutomationReportRender />,
    dynamicform: <CustomFormLayoutRender />,
    myforms: <MyForms transporter={navigateWithData} />,
    mykones: <MyKones transporter={navigateWithData} />,
    clientonboarding: <ClientOnboarding transporter={navigateWithData} />,
    clientonboardingconfig: <ClientOnboardingConfigFlow transporter={navigateWithData} />,
    taskcreation: <TaskCreation transporter={navigateWithData} />,
    staffcreation: <StaffCreation transporter={navigateWithData} />,
    // INNTERNAL REPORTS NAVIGATOR
    intelligence: <ReportDashboard transporter={navigateWithData} />,
    chatgpt: <CygnusGptDashboard transporter={navigateWithData} />,
    flowreport: <FlowReport8879 transporter={navigateWithData} />,
    // Intelligence reports pills: Report component
    BillableReport: <BillableReport transporter={navigateWithData} />,
    MonthlyTaskStatusReport: <MonthlyTaskStatusReport transporter={navigateWithData} />,
    JurisdictionReport: <JurisdictionReport transporter={navigateWithData} />,
    RolesEngagement: <RolesEngagement transporter={navigateWithData} />,
    StaffingReport: <StaffingReport transporter={navigateWithData} />,
    TaskDetailsReport: <TaskDetailsReport transporter={navigateWithData} />,
    WorkDistributionReport: <WorkDistributionReport transporter={navigateWithData} />,
    ComingSoonTemplate: <ComingSoonTemplate transporter={navigateWithData} />
  };

  const [render, setRender] = useState(RENDER_MAP[localStorage.getItem("defaultActiveKey")]);
  const [activeKey, setActiveKey] = useState(localStorage.getItem("defaultActiveKey"));
  const [openConfiguration, setOpenConfiguration] = useState(true);
  const [openReports, setOpenReports] = useState(true);
  const [openApplication, setOpenApplication] = useState(true);
  const [openProfile, setOpenProfile] = useState(true);
  const [openInsights, setOpenInsights] = useState(true);
  const [confirmationModal, setConfirmationModal] = useState(false)
  const [navigationData, setNavigationData] = useState({})

  const continueNavigation = (navigationData) => {
    setActiveKey(navigationData);
    setRender(RENDER_MAP[navigationData]);
  }

  const ConfigurationToggle = ({ children, eventKey }) => {
    const decoratedOnClick = useAccordionButton(eventKey, () =>
      setOpenConfiguration(!openConfiguration)
    );

    return (
      <Nav.Link eventKey="" onClick={decoratedOnClick}>
        <Icon.DatabaseFillGear />
        {isOpen ? <p>&nbsp;Configuration {children}
          {openConfiguration
            ?
            <Icon.ChevronRight className="chevy" />
            :
            <Icon.ChevronDown className="chevy" />
          }
        </p> : ""}

      </Nav.Link>
    );
  }


  const ReportsToggle = ({ children, eventKey }) => {
    const decoratedOnClick = useAccordionButton(eventKey, () =>
      setOpenReports(!openReports)
    );

    return (
      <Nav.Link eventKey="" onClick={decoratedOnClick}>
        <Icon.Clipboard2DataFill />
        {isOpen ? <p>&nbsp;Reports {children}
          {openReports
            ?
            <Icon.ChevronRight className="chevy" />
            :
            <Icon.ChevronDown className="chevy" />
          }
        </p> : ""}

      </Nav.Link>
    );
  }

  const InsightsToggle = ({ children, eventKey }) => {
    const decoratedOnClick = useAccordionButton(eventKey, () =>
      setOpenInsights(!openInsights)
    );

    // return (
    //   <Nav.Link eventKey="" onClick={decoratedOnClick}>
    //     <Icon.Clipboard2DataFill />
    //     {isOpen ? <p>&nbsp;My&nbsp;Insights {children}
    //       {openInsights
    //         ?
    //         <Icon.ChevronRight className="chevy" />
    //         :
    //         <Icon.ChevronDown className="chevy" />
    //       }
    //     </p> : ""}

    //   </Nav.Link>
    // );
  }

  const ProfileToggle = ({ children, eventKey }) => {
    const decoratedOnClick = useAccordionButton(eventKey, () =>
      setOpenProfile(!openProfile)
    );

    return (
      <Nav.Link eventKey="" onClick={decoratedOnClick}>
        <Icon.PersonFillGear />
        {isOpen ? <p>&nbsp;My&nbsp;Profile {children}
          {openProfile
            ?
            <Icon.ChevronRight className="chevy" />
            :
            <Icon.ChevronDown className="chevy" />
          }
        </p> : ""}

      </Nav.Link>
    );
  }

  const ApplicationToggle = ({ children, eventKey }) => {
    const decoratedOnClick = useAccordionButton(eventKey, () =>
      setOpenApplication(!openApplication)
    );

    return (
      <Nav.Link eventKey="" onClick={decoratedOnClick}>
        <Icon.XDiamondFill />
        {isOpen ? <p>&nbsp;Application {children}
          {openApplication
            ?
            <Icon.ChevronRight className="chevy" />
            :
            <Icon.ChevronDown className="chevy" />
          }
        </p> : ""}

      </Nav.Link>
    );
  }

  return (
    <>
      <div className="wrapper">
        <div
          id="mySidenav"
          className="sidenav"
          onMouseEnter={() => openNav()}
          onMouseLeave={() => forcedOpen ? console.log() : closeNav()}
        >
          <ConfirmationModal
            show={confirmationModal}
            onHide={() => setConfirmationModal(false)}
            navigationdata={navigationData}
            stayandsave={() => setConfirmationModal(false)}
            skipandleave={(navigationData) => {
              setConfirmationModal(false)
              continueNavigation(navigationData)
            }
            }
          />
          <Tab.Container
            id="left-tabs-example"
            activeKey={activeKey}
            defaultActiveKey={activeKey}
            className="flex-row-space-center"
          >
            <Nav variant="pills" defaultActiveKey={activeKey} style={{ marginBottom: 50 }}>
              {
                <div className="flex-row-center-start go-home" onClick={() => navigate("/dashboard")}>
                  <img className="sidenav-dashboard-logo" src={require("../../images/dashboard_logo.png")} />
                  <p className="typing-text">{isOpen ? <p>&nbsp;Cygnus&nbsp;Accounting&nbsp;Hub</p> : ""}</p>
                  <div className={forcedOpen ? isOpen ? "sidenav-open" : "sidenav-lock" : "sidenav-lock"}>
                    {
                      forcedOpen ? <Icon.LockFill onClick={() => setForcedOpen(false)} /> : <Icon.UnlockFill onClick={() => setForcedOpen(true)} />
                    }
                  </div>
                </div>
              }
              <hr className="sidenav-divider" />
              {
                (usertype == "Analyst" || usertype == "Firm Admin") && ((availableFeatures.filter(str => str.includes("RPT_"))).length > 0 || availableFeatures.includes("CGPT")) &&
                <Accordion className="sidenav-dropdown">
                  <Nav.Item>
                    <InsightsToggle eventKey="0"></InsightsToggle>
                  </Nav.Item>
                  <Accordion.Collapse eventKey="0">
                    <>
                      {/* Special case to check if the available features has any of the reports */}
                      {(availableFeatures.filter(str => str.includes("RPT_"))).length > 0 &&
                        <Nav.Item onClick={() => navigateWithData("intelligence")}>
                          <Nav.Link eventKey="intelligence">
                            <Icon.PieChartFill />
                            {isOpen ? <p>&nbsp;Visual&nbsp;</p> : ""}
                          </Nav.Link>
                        </Nav.Item>
                      }
                      {availableFeatures.includes("CGPT") &&
                        <Nav.Item onClick={() => navigateWithData("chatgpt")}>
                          <Nav.Link eventKey="chatgpt">
                            <Icon.ChatSquareTextFill />
                            {isOpen ? <p>&nbsp;Conversational&nbsp;</p> : ""}
                          </Nav.Link>
                        </Nav.Item>}
                    </>
                  </Accordion.Collapse>
                </Accordion>
              }
              {
                ((usertype == "Flow Builder" || usertype == "Firm Admin") && ((availableFeatures.filter(str => str.includes("FLW_"))).length > 0)) &&
                <Nav.Item onClick={() => navigateWithData("myflows")}>
                  <Nav.Link eventKey="myflows">
                    <Icon.LayersFill />
                    {isOpen ? <p>&nbsp;My&nbsp;Flows&nbsp;</p> : ""}
                  </Nav.Link>
                </Nav.Item>
              }
              {
                ((usertype == "Analyst" || usertype == "Flow Builder" || usertype == "Firm Admin") && availableFeatures.includes("FLW_CRT")) &&
                <Nav.Item onClick={() => navigateWithData("myapps")}>
                  <Nav.Link eventKey="myapps">
                    <Icon.BoxSeamFill />
                    {isOpen ? <p>&nbsp;My&nbsp;Apps</p> : ""}
                  </Nav.Link>
                </Nav.Item>
              }
              {/* {
                (usertype == "Flow Builder" || usertype == "Firm Admin") &&
                <Nav.Item onClick={() => navigateWithData("flowschedule")}>
                  <Nav.Link eventKey="flowschedule">
                    <Icon.Calendar2WeekFill />
                    {isOpen ? <p>&nbsp;Flow&nbsp;Schedules</p> : ""}
                  </Nav.Link>
                </Nav.Item>
              } */}
              {
                (usertype == "Flow Builder" || usertype == "Firm Admin") &&
                <Accordion className="sidenav-dropdown">
                  <Nav.Item>
                    <ConfigurationToggle eventKey="0"></ConfigurationToggle>
                  </Nav.Item>
                  <Accordion.Collapse eventKey="0">
                    <>
                      {
                        (availableFeatures.includes("CRD_CNFG")) &&
                        <Nav.Item onClick={() => navigateWithData("credentials")}>
                          <Nav.Link eventKey="credentials">
                            <Icon.ShieldLockFill />
                            {isOpen ? <p>&nbsp;App&nbsp;Credentials</p> : ""}
                          </Nav.Link>
                        </Nav.Item>}
                      {
                        (availableFeatures.includes("MPNG_CNFG")) &&
                        <Nav.Item onClick={() => navigateWithData("mapping")}>
                          <Nav.Link eventKey="mapping">
                            <Icon.Diagram3Fill />
                            {isOpen ? <p>&nbsp;Mapping</p> : ""}
                          </Nav.Link>
                        </Nav.Item>}
                      {/* {
                      (availableFeatures.includes("FLW_CRT")) &&
                      <Nav.Item onClick={() => navigateWithData("manage")}>
                        <Nav.Link eventKey="manage">
                          <Icon.PeopleFill />
                          {isOpen ? <p>&nbsp;Manage&nbsp;Users</p> : <>&nbsp;</>}
                        </Nav.Link>
                      </Nav.Item>} */}
                    </>
                  </Accordion.Collapse>
                </Accordion>
              }

              {
                (usertype == "Analyst" || usertype == "Flow Builder" || usertype == "Firm Admin") &&
                <Accordion className="sidenav-dropdown">
                  <Nav.Item>
                    <ReportsToggle eventKey="0"></ReportsToggle>
                  </Nav.Item>
                  <Accordion.Collapse eventKey="0">
                    <>
                      {/* <Nav.Item onClick={() => navigateWithData("report")}>
                        <Nav.Link eventKey="report">
                          <Icon.PlusSlashMinus />
                          {isOpen ? <p>&nbsp;Reports</p> : ""}
                        </Nav.Link>
                      </Nav.Item> */}
                      {
                        (availableFeatures.includes("RPRT_MNT")) &&
                        <Nav.Item onClick={() => navigateWithData("maintenancereport")}>
                          <Nav.Link eventKey="maintenancereport">
                            <Icon.GearWideConnected />
                            {isOpen ? <p>&nbsp;Integration&nbsp;Reports</p> : ""}
                          </Nav.Link>
                        </Nav.Item>}
                      {
                        (availableFeatures.includes("FLW_USM")) &&
                        <Nav.Item onClick={() => navigateWithData("usagemetricreport")}>
                          <Nav.Link eventKey="usagemetricreport">
                            <Icon.GearWideConnected />
                            {isOpen ? <p>&nbsp;Usage&nbsp;Metric&nbsp;Reports</p> : ""}
                          </Nav.Link>
                        </Nav.Item>}
                      {
                        (availableFeatures.includes("RPRT_ATMN")) &&
                        <Nav.Item onClick={() => navigateWithData("automatedreport")}>
                          <Nav.Link eventKey="automatedreport">
                            <Icon.Clipboard2CheckFill />
                            {isOpen ? <p>&nbsp;Automation&nbsp;Reports</p> : ""}
                          </Nav.Link>
                        </Nav.Item>}
                      {(availableFeatures.filter(str => str.includes("RPT_"))).length > 0 &&
                        <Nav.Item onClick={() => navigateWithData("flowreport")}>
                          <Nav.Link eventKey="flowreport">
                            <Icon.BarChartSteps />
                            {isOpen ? <p>&nbsp;8879&nbsp;Report&nbsp;</p> : ""}
                          </Nav.Link>
                        </Nav.Item>}
                    </>
                  </Accordion.Collapse>
                </Accordion>
              }
              {
                ((usertype == "Analyst" || usertype == "Flow Builder" || usertype == "Firm Admin") && availableFeatures.includes("FLW_CRT")) &&
                <Nav.Item onClick={() => navigateWithData("recommendation")}>
                  <Nav.Link eventKey="recommendation">
                    <Icon.BookmarkStarFill />
                    {isOpen ? <p>&nbsp;Recommendations&nbsp;</p> : ""}
                  </Nav.Link>
                </Nav.Item>
              }
              {
                (usertype == "Super Admin") &&
                <Nav.Item onClick={() => navigateWithData("superadmin")}>
                  <Nav.Link eventKey="superadmin">
                    <Icon.PersonFillGear />
                    {isOpen ? <p>&nbsp;Firm&nbsp;management&nbsp;</p> : ""}
                  </Nav.Link>
                </Nav.Item>
              }
              {
                (usertype == "Super Admin") &&
                <Nav.Item onClick={() => navigateWithData("myforms")}>
                  <Nav.Link eventKey="myforms">
                    <Icon.FilterSquareFill />
                    {isOpen ? <p>&nbsp;Form&nbsp;templates&nbsp;</p> : ""}
                  </Nav.Link>
                </Nav.Item>
              }
              {
                (usertype == "Firm Admin" && availableFeatures.includes("K1_FRM")) &&
                <Accordion className="sidenav-dropdown">
                  <Nav.Item>
                    <ApplicationToggle eventKey="0"></ApplicationToggle>
                  </Nav.Item>
                  <Accordion.Collapse eventKey="0">
                    <>
                      {/* {
                        (availableFeatures.includes("FORM_MY")) &&
                        <Nav.Item onClick={() => navigateWithData("myforms")}>
                          <Nav.Link eventKey="myforms">
                            <Icon.FilterSquareFill />
                            {isOpen ? <p>&nbsp;My&nbsp;forms&nbsp;</p> : ""}
                          </Nav.Link>
                        </Nav.Item>}
                      {
                        (availableFeatures.includes("FORM_CRT")) &&
                        <Nav.Item onClick={() => navigateWithData("dynamicform")}>
                          <Nav.Link eventKey="dynamicform">
                            <Icon.StickiesFill />
                            {isOpen ? <p>&nbsp;Create&nbsp;a&nbsp;form&nbsp;</p> : ""}
                          </Nav.Link>
                        </Nav.Item>}
                      {
                        (availableFeatures.includes("CLT_OBR")) &&
                        <Nav.Item onClick={() => {
                          navigate("/clientonboarding")
                        }}>
                          <Nav.Link eventKey="clientonboarding">
                            <Icon.PersonFillUp />
                            {isOpen ? <p>&nbsp;Client&nbsp;onboarding</p> : ""}
                          </Nav.Link>
                        </Nav.Item>}
                      {
                        (availableFeatures.includes("CLT_OBR")) &&
                        <Nav.Item onClick={() => navigateWithData("clientonboardingconfig")} style={{visibility: "hidden", display: "None"}}>
                          <Nav.Link eventKey="clientonboardingconfig">
                            <Icon.PersonFillUp />
                            {isOpen ? <p>&nbsp;Client&nbsp;onboarding&nbsp;config</p> : ""}
                          </Nav.Link>
                        </Nav.Item>}
                      {
                        (availableFeatures.includes("TSK_CRT")) &&
                        <Nav.Item onClick={() => navigateWithData("taskcreation")}>
                          <Nav.Link eventKey="taskcreation">
                            <Icon.EaselFill />
                            {isOpen ? <p>&nbsp;Task&nbsp;creation&nbsp;</p> : ""}
                          </Nav.Link>
                        </Nav.Item>}
                      {
                        (availableFeatures.includes("STF_CRT")) &&
                        <Nav.Item onClick={() => navigateWithData("staffcreation")}>
                          <Nav.Link eventKey="staffcreation">
                            <Icon.PersonBadgeFill />
                            {isOpen ? <p>&nbsp;Staff&nbsp;creation&nbsp;</p> : ""}
                          </Nav.Link>
                        </Nav.Item>} */}
                      {
                        (availableFeatures.includes("K1_FRM")) &&
                        <Nav.Item onClick={() => redirectToExternalCygnusSites("K1")}>
                          <Nav.Link eventKey="mykones">
                            <Icon.ArrowUpRightSquareFill />
                            {isOpen ? <p>&nbsp;K1s&nbsp;</p> : ""}
                          </Nav.Link>
                        </Nav.Item>
                      }
                      {
                        <Nav.Item onClick={() => redirectToExternalCygnusSites("MDM")}>
                          <Nav.Link eventKey="redirecttomdm">
                            <Icon.ArrowUpRightSquareFill />
                            {isOpen ? <p>&nbsp;Client Data Management&nbsp;</p> : ""}
                          </Nav.Link>
                        </Nav.Item>
                      }
                    </>
                  </Accordion.Collapse>
                </Accordion>
              }
              {
                <Row className="sidenav-bottom-container">
                  <div className="sidenav-firm-icon">
                    <Icon.PersonWorkspace style={{ height: 25, width: 25 }} />
                  </div>
                  <div style={{ width: "fit-content", padding: 0, marginLeft: 5 }}>
                    {isOpen ? <p style={{ fontSize: "var(--small_font)", margin: 0 }}>Logged&nbsp;in&nbsp;from&nbsp;</p> : ""}
                    {isOpen ? <p style={{ fontWeight: 600, marginTop: 0, width: 80, maxWidth: 80 }}>{firmname}</p> : ""}
                  </div>
                  {
                    isOpen
                      ?
                      <div
                        className="sidenav-logout-container"
                        onMouseEnter={() => sidenavOpenDoor()}
                        onMouseLeave={() => sidenavCloseDoor()}>
                        {
                          logoutIcon
                            ?
                            <><Icon.DoorOpenFill className="sidenav-logout" onClick={() => handleLogout()} />&nbsp;Logout</>
                            :
                            <><Icon.DoorClosedFill className="sidenav-logout" onClick={() => handleLogout()} />&nbsp;Logout</>
                        }
                      </div>
                      :
                      <></>
                  }
                </Row>
              }
            </Nav>
          </Tab.Container>
        </div>
        <div id="dashboard-content">{render}</div>
      </div>
    </>
  );
};

export default Dashboard;
